// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jx7K","divider":"styles_divider__202Rd"};